import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { getOwner } from '@ember/application';
import { action } from '@ember/object';

export default class AppRoute extends Route {
  @service session;
  @service intl;
  @service notify;

  async beforeModel() {
    this.session.setup();

    const config = getOwner(this).resolveRegistration('config:environment');
    this.intl.setLocale(config.APP.locale);
    this.intl.setOnMissingTranslation((key, locales, options) => {
      if (options?.fallbackValue !== undefined) {
        return options.fallbackValue;
      }
      return `Missing translation "${key}" for locale "${locales.join(', ')}"`;
    });
  }

  async model() {
    if (this.session.isAuthenticated) {
      try {
        this.notify.startWorkingOnIt();
        await this.session.refreshAccessToken();
      } catch (e) {
        this.session.invalidate();
      } finally {
        this.notify.stopWorkingOnIt();
      }
    }
  }

  @action
  loading(transition) {
    this.notify.startWorkingOnIt();
    transition.promise.finally(() => {
      this.notify.stopWorkingOnIt();
    });
    return true;
  }

  @action
  error(error) {
    this.notify.alert(error?.message ?? this.intl.t('error-message'), error);
    return true;
  }
}
